import { render } from "./ChimiquesComp.vue?vue&type=template&id=7f2dda82&scoped=true"
import script from "./ChimiquesComp.vue?vue&type=script&lang=js"
export * from "./ChimiquesComp.vue?vue&type=script&lang=js"

import "./ChimiquesComp.vue?vue&type=style&index=0&id=7f2dda82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2dda82"]])

export default __exports__